import { Theme } from '@emotion/react';
import { SxProps, Typography } from '@mui/material';
import { Box } from '@mui/system';

interface CompanyLogoProps {
  companyName: string;
  logoUrl?: string;
  sx?: SxProps<Theme>;
}

export function CompanyLogo({ logoUrl, companyName, sx }: CompanyLogoProps) {
  if (logoUrl) {
    return (
      <Box
        component="img"
        src={logoUrl}
        alt="logo company"
        sx={{
          maxWidth: 400,
          objectFit: 'contain',
          ...sx,
        }}
      />
    );
  }

  return (
    <Typography
      variant="h6"
      fontWeight="bold"
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        maxWidth: 240,
        ...sx,
      }}
    >
      {companyName}
    </Typography>
  );
}
